<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">

<p>{{data.body}}</p>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="confirm()" cdkFocusRegionstart>Sí</button>
</mat-dialog-actions>
